import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do restaurants get more reservations and orders?",
    "a": "Google Business Profile is the highest-leverage channel — menu, photos, reservations, online ordering. Your site comes second, and direct ordering on the site cuts delivery-app fees. Together they drive in-house volume."
  },
  {
    "q": "Is SEO worth it for restaurants?",
    "a": "Yes — 'restaurants near me' and cuisine-specific searches are massive. Ranking captures the dinner-decision moment that delivery apps profit from."
  },
  {
    "q": "Should restaurants do their own online ordering?",
    "a": "Yes — even 50/50 with third-party apps saves thousands per month. We integrate direct ordering on the site with kitchen workflows that don't break the line."
  },
  {
    "q": "Is Google Ads worth it for restaurants?",
    "a": "For events, catering, and slow-night promotions yes. For everyday traffic, GBP and SEO drive more value per dollar."
  },
  {
    "q": "Do you market multi-location restaurant groups?",
    "a": "Yes — each location gets its own GBP, its own page, and its own local SEO so each ranks in its own neighborhood Map Pack."
  }
];

export const Route = createFileRoute("/restaurant-marketing-colorado")({
  head: () =>
    industryMarketingHead("Restaurant", "restaurant or café", "restaurant-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Restaurant"}
      industryLower={"restaurant or café"}
      slug={"restaurant-marketing-colorado"}
      subheadline={"We help Colorado restaurants and cafés fill seats, drive online orders, and build a regular guest base — without giving everything to DoorDash."}
      painPoints={["Third-party delivery apps eat 25–30% of every ticket","Your Google Business Profile is your most-visited 'site' and it's underbuilt","Slow weeks aren't predictable — there's no marketing engine to fill them"]}
      serviceDescriptions={{
        seo: "Rank for cuisine, neighborhood, and 'restaurants near me' searches in every Colorado market.",
        googleMaps: "Own the Map Pack with a fully built GBP — menu, photos, reservations, and review velocity that compounds.",
        webDesign: "Mobile-first sites with direct online ordering that bypasses delivery-app fees.",
        ppc: "Local Google Ads tuned to fill slow shifts and drive reservations during high-margin times.",
        geoAi: "Get cited when diners ask ChatGPT 'best brunch in Denver' or 'Italian restaurant near me'.",
        socialMedia: "Instagram-first content from your kitchen that converts followers into guests.",
      }}
      testimonial={{"quote":"We cut delivery-app dependence in half and our slow nights are now bookable. The site finally feels like the restaurant.","role":"Owner, Independent Restaurant","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Restaurant marketing in Colorado Springs","description":"Fill seats across downtown, Old Colorado City, and Briargate dining districts."},{"to":"/denver-digital-marketing","label":"Restaurant marketing in Denver","description":"Compete in Denver's saturated independent restaurant scene."},{"to":"/boulder-digital-marketing","label":"Restaurant marketing in Boulder","description":"Drive reservations across Pearl Street and the Boulder food scene."}]}
    />
  ),
});
